const EMDR_CASE_CONCEPTUALIZATION_NOTE = {
  type: "note",
  title: "EMDR Therapy Case Conceptualization Note",
  elements: [
    {
      id: "1a2b3c4d-5678-90ab-cdef-1234567890ab",
      type: "paragraph",
      title: "Presenting Problem",
    },
    {
      id: "2b3c4d5e-6789-01ab-cdef-2345678901bc",
      type: "checkboxes",
      title: "Clinical Theme(s)",
      options: [
        { id: "da0048a1-f0e6-4991-865c-30043c4fe76a", title: "Responsibility" },
        { id: "eb22d09f-2cd2-40df-8776-d3ca7336fbb9", title: "Safety" },
        { id: "f6533eed-8d86-4242-a797-5496c7d3bfab", title: "Power" },
      ],
    },
    {
      id: "3c4d5e6f-7890-12ab-cdef-3456789012cd",
      type: "paragraph",
      title: "Present Triggers",
    },
    {
      id: "4d5e6f7g-8901-23ab-cdef-4567890123de",
      type: "paragraph",
      title:
        "Past Experiences (from Float Back and/or Affect Scan) with age, if known",
    },
    {
      id: "5e6f7g8h-9012-34ab-cdef-5678901234ef",
      type: "paragraph",
      title: "Desired Outcomes for the Future",
    },
    {
      id: "6f7g8h9i-0123-45ab-cdef-6789012345fg",
      type: "paragraph",
      title: "Internal and External Resources",
    },
    {
      id: "8h9i0j1k-2345-67ab-cdef-8901234567hi",
      type: "paragraph",
      title: "Treatment Plan and/or Target Memory for Reprocessing",
    },
  ],
};

const EMDR_TREATMENT_SUMMARY_NOTE = {
  type: "note",
  title: "EMDR Therapy Treatment Summary Note",
  elements: [
    {
      id: "1a2b3c4d-5678-90ab-cdef-1234567890ab",
      type: "paragraph",
      title: "Presenting Issue",
    },
    {
      id: "2b3c4d5e-6789-01ab-cdef-2345678901bc",
      type: "radios",
      title: "Target memory is",
      options: [
        { id: "fca3645d-d1c7-4ea4-9afa-0e38db20ce54", title: "Past" },
        { id: "5f3ff898-0e0a-439b-be61-755d606e62ae", title: "Present" },
        { id: "86aa3e7e-6c8c-4bfa-8221-a93b86318e4c", title: "Future" },
      ],
    },
    {
      id: "3c4d5e6f-7890-12ab-cdef-3456789012cd",
      type: "paragraph",
      title: "Target Memory",
    },
    {
      id: "4d5e6f7g-8901-23ab-cdef-4567890123de",
      type: "short-answer",
      title: "Image",
    },
    {
      id: "5e6f7g8h-9012-34ab-cdef-5678901234ef",
      type: "short-answer",
      title: "Negative Cognition (NC)",
    },
    {
      id: "6f7g8h9i-0123-45ab-cdef-6789012345fg",
      type: "short-answer",
      title: "Positive Cognition (PC)",
    },
    {
      id: "7g8h9i0j-1234-56ab-cdef-7890123456gh",
      type: "short-answer",
      title: "Validity of Cognition (VoC)",
    },
    {
      id: "8h9i0j1k-2345-67ab-cdef-8901234567hi",
      type: "short-answer",
      title: "Emotions/Feelings",
    },
    {
      id: "9i0j1k2l-3456-78ab-cdef-9012345678ij",
      type: "short-answer",
      title: "Subjective Units of Disturbance (SUD)",
    },
    {
      id: "0j1k2l3m-4567-89ab-cdef-0123456789jk",
      type: "short-answer",
      title: "Physical/Body Sensations",
    },
    {
      id: "1k2l3m4n-5678-90ab-cdef-1234567890kl",
      type: "radios",
      title: "Target Memory status",
      options: [
        { id: "f1d49cfb-3be1-4b89-b22e-0d549bf6afef", title: "Complete" },
        { id: "de44c12d-71b1-4ce0-94ea-5272e9ade95e", title: "Incomplete" },
      ],
    },
    {
      id: "2l3m4n5o-6789-01ab-cdef-2345678901lm",
      type: "radios",
      title: "Stabilization exercise used at end of session?",
      options: [
        { id: "cf69b197-f391-49db-b27b-caf9bc813612", title: "Safe Place" },
        { id: "b4c4b734-e08d-4157-a639-a53b9ccb4e4b", title: "Container" },
        { id: "5412a5b9-0e25-45a5-8767-120d12081593", title: "Light Stream" },
        { id: "575ca346-104f-48a1-a277-67a960df5f1e", title: "Breathing" },
        { id: "de0d6810-2935-40f7-adf1-2d79d4fe5e1f", title: "Other" },
        { id: "b3227cd3-cda4-481e-8562-ab332e0d84c3", title: "No, not needed" },
      ],
    },
    {
      id: "3m4n5o6p-7890-12ab-cdef-3456789012mn",
      type: "radios",
      title: "Client stability when leaving session",
      options: [
        { id: "fefb2919-442e-4ee6-b827-808a03edc5a7", title: "Poor" },
        { id: "0210160a-2285-4bf6-bd27-c6d1cff299c9", title: "Fair" },
        { id: "5e605b3a-1b8d-4fa7-ba7b-735e205d538b", title: "Good" },
        { id: "d0c0cc55-7692-4a05-b08a-30d9510eb642", title: "Excellent" },
      ],
    },
    {
      id: "4n5o6p7q-8901-23ab-cdef-4567890123op",
      type: "checkboxes",
      title: "Bilateral Stimulation (BLS) used",
      options: [
        {
          id: "ff510067-7af6-41ef-abe0-0d6fec20b512",
          title: "Eye Movement (Manual)",
        },
        {
          id: "cc9b3d73-56ca-403b-b458-e1774d88957d",
          title: "Eye Movement (Light Bar)",
        },
        { id: "a28a1c66-b511-41c4-930e-96ad8f798099", title: "Tapping" },
        { id: "45eec871-19ef-4ba0-8f8d-19fee6cde9b8", title: "Auditory" },
        { id: "dd47ea70-8d80-40f1-8587-15b9ee7bc5ae", title: "Other" },
      ],
    },
    {
      id: "5o6p7q8r-9012-34ab-cdef-5678901234pq",
      type: "paragraph",
      title:
        "Treatment Summary Notes (including change in SUD and/or VoC, if applicable)",
    },
    {
      id: "6p7q8r9s-0123-45ab-cdef-6789012345qr",
      type: "paragraph",
      title:
        "Issues or associations that arose to be re-evaluated at a later time",
    },
  ],
};

const CREDIT_CARD_AUTHORIZATION_FORM = {
  type: "form",
  title: "Credit Card Authorization Form",
  elements: [
    {
      id: "item_1719343870530",
      type: "short-answer",
      title: "Full name as written on credit card",
      isRequired: false,
    },
    {
      id: "item_1719343916476",
      type: "radios",
      title: "Type of card",
      options: [
        { id: "option-0", title: "VISA" },
        { id: "option-1", title: "MasterCard" },
        { id: "option-2", title: "AmEx" },
        { id: "option-3", title: "Discover" },
      ],
      isRequired: false,
    },
    {
      id: "item_1719343907494",
      type: "short-answer",
      title: "Card number (please add spaces)",
      isRequired: false,
    },
    {
      id: "item_1719344015149",
      type: "short-answer",
      title: "Expiration Date",
      isRequired: false,
    },
    {
      id: "item_1719344023242",
      type: "short-answer",
      title: "Security Code",
      isRequired: false,
    },
    {
      id: "item_1719344034042",
      type: "short-answer",
      title: "Billing Address, including Zip Code",
      isRequired: false,
    },
  ],
  formType: "custom",
};

const ADULT_ADOLESCENT_CBIT_INTAKE_FORM = {
  type: "form",
  title: "Adult and Adolescent CBIT Intake Form",
  elements: [
    {
      id: "21fd6fe8-4b64-48a7-90c4-661d970e822a",
      type: "date",
      title: "Date",
      isRequired: false,
      description: "",
    },
    {
      id: "2b3c4d5e-6789-01ab-cdef-2345678901bc",
      type: "short-answer",
      title: "Patient Name",
    },
    {
      id: "90556446-7296-468f-b1f7-7d733bbde6c9",
      type: "date",
      title: "Date of Birth",
      isRequired: false,
      description: "",
    },
    {
      id: "4d5e6f7g-8901-23ab-cdef-4567890123de",
      type: "short-answer",
      title: "Email",
    },
    {
      id: "5e6f7g8h-9012-34ab-cdef-5678901234ef",
      type: "short-answer",
      title: "Home Address",
    },
    {
      id: "6f7g8h9i-0123-45ab-cdef-6789012345fg",
      type: "short-answer",
      title: "Referred By",
    },
    {
      id: "7g8h9i0j-1234-56ab-cdef-7890123456gh",
      type: "paragraph",
      title:
        "Please list your current tics, age of onset & tic progression. If known, also indicate where or when the tics happen the most.",
    },
    {
      id: "8h9i0j1k-2345-67ab-cdef-8901234567hi",
      type: "checkboxes",
      title: "Current diagnosis and co-existing conditions",
      options: [
        {
          id: "42e17eaf-9b1c-4f27-9ff2-ea70e7f2d849",
          title: "Chronic Tic Disorder",
        },
        {
          id: "fa1ec9b0-8d3f-493b-9148-833123304e29",
          title: "Tourette Syndrome",
        },
        { id: "24e1ca6c-d221-4804-8582-dfaf417b4201", title: "ADHD" },
        { id: "b28920d4-bb64-4807-a7ab-e1cdca0945cd", title: "ADD" },
        { id: "235ac4ba-44c4-4974-bfa3-cd700f2c6930", title: "Anxiety" },
        {
          id: "2b8b0cf5-758b-45ee-a3d6-790ac5171dcd",
          title: "Autism Spectrum Disorder",
        },
        {
          id: "6f2b00d2-1956-4d0e-8a41-041f44a41a4f",
          title: "Behavioral Issues",
        },
        { id: "96f350b6-e3cb-42a8-8110-330725adb93d", title: "Bullying" },
        { id: "b8e8c2ff-1667-4ae7-a724-909c6f2cece6", title: "Depression" },
        {
          id: "5c3ac88f-1142-4311-a78c-652a372af218",
          title: "Executive Functioning Difficulties",
        },
        {
          id: "f7a5994c-031c-4895-b15c-bd59243b60e0",
          title: "Learning Disabilities",
        },
        { id: "1a37abbe-df6d-4ff2-850b-c619f2e61820", title: "OCB" },
        { id: "2f3b5208-3326-4960-a5f2-31087dc2aa85", title: "OCD" },
        {
          id: "44fc632c-6e88-4dc9-83a8-d088f84f3df1",
          title: "Sensory Processing Issues",
        },
        {
          id: "f787a18e-8d66-4c40-a4ba-658e95be0990",
          title: "Social Skill Deficits",
        },
      ],
    },
    {
      id: "9i0j1k2l-3456-78ab-cdef-9012345678ij",
      type: "paragraph",
      title:
        "Significant medical history (i.e. Illnesses, surgeries, hospitalizations, etc.)",
    },
    {
      id: "0j1k2l3m-4567-89ab-cdef-0123456789jk",
      type: "paragraph",
      title:
        "Family history of tic disorders, Tourette Syndrome, or other related disorders (autism, anxiety, depression, OCD, ADHD, etc.)",
    },
    {
      id: "1k2l3m4n-5678-90ab-cdef-1234567890kl",
      type: "paragraph",
      title: "Current living situation",
    },
    {
      id: "2l3m4n5o-6789-01ab-cdef-2345678901lm",
      type: "checkboxes",
      title: "Current medications (select all that apply)",
      options: [
        {
          id: "03bcfb6c-b19b-49a7-bc30-1b1e6367ba16",
          title: "Clonazepam (Klonopin)",
        },
        { id: "c8f272bb-3ef1-4f33-a3fa-05fe3c65e6f2", title: "Clonidine" },
        { id: "de538003-b596-4fb1-83e0-125328281ad0", title: "Other" },
      ],
    },
    {
      id: "3m4n5o6p-7890-12ab-cdef-3456789012mn",
      type: "checkboxes",
      title:
        "Activities of Daily Living (How do tics impact these activities?)",
      options: [
        {
          id: "8c8dde66-245f-4790-9d45-b02e3bf0c85c",
          title: "Relationships with friends/family members",
        },
        {
          id: "516455c4-66c9-485c-ac03-d020dbb8bd9d",
          title: "Performing self-care and personal hygiene",
        },
        {
          id: "c8b4cbac-a5e4-45eb-9691-c1ad55eb7690",
          title: "Eating/Food Prep",
        },
        { id: "982d87d0-df50-4971-b1e5-b1e6a4951201", title: "Sleep" },
      ],
    },
    {
      id: "4n5o6p7q-8901-23ab-cdef-4567890123op",
      type: "paragraph",
      title: "Educational Information",
    },
    {
      id: "5o6p7q8r-9012-34ab-cdef-5678901234pq",
      type: "paragraph",
      title: "Vocational Information",
    },
    {
      id: "6p7q8r9s-0123-45ab-cdef-6789012345qr",
      type: "paragraph",
      title: "Do your tics impact participation in community activities?",
    },
    {
      id: "7p8q9r0s-1234-56ab-cdef-7890123456rs",
      type: "paragraph",
      title:
        "What are your hobbies and interests? Do your tics impact your ability to engage in these activities?",
    },
  ],
  formType: "custom",
};

export const PREBUILT_NOTES_EXAMPLE = [
  EMDR_CASE_CONCEPTUALIZATION_NOTE,
  EMDR_TREATMENT_SUMMARY_NOTE,
] as const;

export const PREBUILT_FORMS_EXAMPLE = [
  ADULT_ADOLESCENT_CBIT_INTAKE_FORM,
  CREDIT_CARD_AUTHORIZATION_FORM,
];
